import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Grid,
  makeStyles,
  withStyles,
  Tab,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';

import DetailsPanel from '../../ObjectiveDetails/DetailsPanel';
import EventLogPanel from './EventLog/Panel';
import RelatedObjectives from './RelatedObjectives';

const StyledBadge = withStyles(() => ({
  badge: {
    right: -18,
    top: 8,
    padding: '4px',
    backgroundColor: '#A6A6A6',
    width: '25px',
    height: '25px',
    borderRadius: '50%',
    color: '#FFFFFF',
    fontWeight: 600
  }
}))(Badge);

const useStyles = makeStyles(() => ({
  panel: {
    padding: 0
  },
  tabs: {
    marginBottom: '16px'
  },
  connectedGoalsTab: {
    width: '100%',
    maxWidth: '320px'
  }
}));

const Tabs = ({ objectiveRelations, objective, onSubmitSuccess }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));

  const [ tabValue, setTabValue ] = useState('1');

  return (
    <TabContext value={ tabValue }>
      <Grid item xs={ 12 }>
        <TabList
          className={ classes.tabs }
          onChange={ (event, newValue) => {
            setTabValue(newValue);
          } }
          orientation={ md ? 'horizontal' : 'vertical' }
        >
          <Tab label={ t('objective.button.tab.details') } value="1" />
          <Tab
            className={ classes.connectedGoalsTab }
            label={
              <StyledBadge
                badgeContent={ objectiveRelations.length }
                max={ 999 }
                overlap='rectangular'
              >
                { t('objective.button.tab.relations')}
              </StyledBadge>
            }
            value="2"
          />
          <Tab label={ t('objective.button.tab.eventlog') } value="3" />
        </TabList>
      </Grid>
      <TabPanel value='1' className={ classes.panel }>
        <Grid container spacing={ 2 }>
          <DetailsPanel
            objective={ objective }
            onSubmitSuccess={ onSubmitSuccess }
          />
        </Grid>
      </TabPanel>
      <TabPanel value='2' className={ classes.panel }>
        <RelatedObjectives
          objective={ objective }
          objectiveRelations={ objectiveRelations }
        />
      </TabPanel>
      <TabPanel value='3' className={ classes.panel }>
        <EventLogPanel
          enabled={ tabValue === '3' }
          objective={ objective }
          createdAt={ objective?.createdAt }
          owner={ objective?.owner[0] }
        />
      </TabPanel>
    </TabContext>
  );
};

export default Tabs;